"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetProductListMode = exports.getProductListModesProps = exports.getMode = void 0;
var _contexts = require("../contexts");
const getMode = (mode, totalItemCount) => {
  if (mode.type === 'HYBRID') {
    const {
      threshold
    } = mode;
    return totalItemCount >= threshold ? 'LIST' : 'CAROUSEL';
  }
  return mode.type;
};
exports.getMode = getMode;
const getProductListModesProps = (mode, productListMode) => ({
  mode: productListMode,
  carousel: mode.type === 'CAROUSEL' ? mode : mode.type === 'HYBRID' ? mode.carousel : undefined,
  list: mode.type === 'LIST' ? mode : mode.type === 'HYBRID' ? mode.list : undefined
});
exports.getProductListModesProps = getProductListModesProps;
const useGetProductListMode = () => {
  const {
    mode = {
      type: 'LIST'
    },
    totalItemCount = 0
  } = (0, _contexts.useProductList)();
  const productListMode = getMode(mode, totalItemCount);
  return getProductListModesProps(mode, productListMode);
};
exports.useGetProductListMode = useGetProductListMode;
